<template>
  <span class="mail-address">
    <span>{{ address }}</span>
    <button v-if="address" type="button" class="mail-copy-button" :title="copied ? 'Kopiert' : 'Adresse kopieren'" :aria-label="copied ? 'Adresse kopiert' : address + ' kopieren'" @click="copy"><v-icon aria-hidden="true">{{ copied ? 'mdi-check' : 'mdi-content-copy' }}</v-icon></button>
    <span class="mail-sr-only" role="status">{{ copied ? 'Adresse kopiert' : '' }}</span>
    <span v-if="error" class="muted" role="alert">{{ error }}</span>
  </span>
</template>
<script>
export default {
  props: { address: String },
  data: () => ({ copied: false, error: "", timer: null, stopped: false }),
  beforeDestroy() { this.stopped = true; clearTimeout(this.timer) },
  methods: {
    async copy() {
      this.error = ""; this.copied = false; clearTimeout(this.timer)
      try {
        if (navigator.clipboard && window.isSecureContext) await navigator.clipboard.writeText(this.address)
        else {
          const field = document.createElement("textarea"), focus = document.activeElement
          field.value = this.address; field.readOnly = true
          field.style.cssText = "position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;font-size:1rem"
          document.body.appendChild(field)
          try { field.select(); if (!document.execCommand("copy")) throw new Error("copy") }
          finally { field.remove(); if (focus && focus.focus) focus.focus({ preventScroll: true }) }
        }
        if (this.stopped) return
        this.copied = true; this.timer = setTimeout(() => { this.copied = false }, 2000)
      } catch (_) { if (!this.stopped) this.error = "Kopieren nicht möglich. Bitte die Adresse markieren und kopieren." }
    },
  },
}
</script>
